import { getApi } from '../../../utils/api'

export function getUserProfileTabCounters({ params, userId }) {
  return getApi({
    endpoint: `idwell-api/api/v3/profile/${userId}/counters/`,
    params,
  })
}
